module.exports = __webpack_public_path__ + "img/6.eb2beb44.webp";